<template>
  <div>
    
  </div>
</template>

<script>
/**
 * 历史记录跳转当前路由辅助模板
 */
export default {
  name: "help",
  created(){
    if(!this.$route.query.ncid && !this.$route.query.ncid) {
      this.$router.replace('/Home');
      return;
    }
    let routeObj = {
      path: "/player",
      query: {
        ncid: this.$route.query.ncid,
        nid: this.$route.query.nid,
        acname: this.$route.query.acname,
        current_time: this.$route.query.current_time,
        ver: this.$route.query.ver,
      },
    };
    this.$router.replace(routeObj);
  }
}
</script>